import { memo } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import AddIcon from "@mui/icons-material/Add";
import { Controller, type Control } from "react-hook-form";

import type {
  QuestionnaireFormValues,
  QuestionnaireQuestionFormValues,
} from "../types";
import ActiveQuestionForm from "./ActiveQuestionForm";

export interface QuestionsSectionProps {
  activeQuestionIndex: number;
  activeQuestion?: QuestionnaireQuestionFormValues;
  isQuestionnaireEmpty: boolean;
  control: Control<QuestionnaireFormValues>;
  Controller: typeof Controller;
  isConfigCollapsed: boolean;
  onAddQuestion: () => void;
  isAddQuestionDisabled?: boolean;
}

const QuestionsSection = memo(
  ({
    activeQuestionIndex,
    activeQuestion,
    isQuestionnaireEmpty,
    control,
    Controller,
    isConfigCollapsed,
    onAddQuestion,
    isAddQuestionDisabled,
  }: QuestionsSectionProps) => (
    <>
      <Card variant="outlined">
        <CardContent>
          <Stack spacing={2}>
            <Typography variant="subtitle2" fontWeight={500}>
              Itens do questionário
            </Typography>
            {isQuestionnaireEmpty || !activeQuestion ? (
              <Alert severity="info">
                Nenhuma pergunta criada ainda. Clique em{" "}
                <strong>Adicionar pergunta</strong> abaixo para começar o
                questionário.
              </Alert>
            ) : (
              <ActiveQuestionForm
                activeQuestionIndex={activeQuestionIndex}
                activeQuestion={activeQuestion}
                control={control}
                Controller={Controller}
              />
            )}
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="outlined"
                disabled={isAddQuestionDisabled}
                onMouseDown={(e) => e.preventDefault()}
                onClick={(e) => {
                  e.stopPropagation();
                  onAddQuestion();
                }}
                startIcon={<AddIcon />}
              >
                Proxima pergunta
              </Button>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </>
  ),
);

QuestionsSection.displayName = "QuestionsSection";

export default QuestionsSection;
